import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import * as serviceWorker from './serviceWorker';

// Load I18N
import './i18n-ok';

// Load app components
import Root from './components/Root';

// Load styles
import 'font-awesome/css/font-awesome.min.css';
import './index.css';

// Prepare root
const container = document.getElementById('root');
const root = createRoot(container);

// Create umpi theme:
const theme = createTheme({
    palette: {
        type: 'light',
        primary: {
            main: '#114a90' // BLUE
        },
        secondary: {
            main: '#fdd60f' // YELLOW
        }
    }
});

// Render all
root.render(
    <React.Fragment>
        <ThemeProvider theme={theme}>
            <Root />
        </ThemeProvider>
    </React.Fragment>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
